import { ParticipantVideoDisableReason } from '../../webrtc/session';

export type Stats = {
  participantVideoDisabledWarningByQuality: number;
  participantVideoDisabledByQuality: number;
  /**
   * By other reason (codec not supported, etc.)
   */
  participantVideoDisabledByOtherReason: number;
  participantVideoDisabledByTurningOff: number;
  /**
   * For optimization purposes (when participant is not visible on the screen)
   */
  participantVideoDisabledByOptimization: number;
};

const disabledReasonsToStatKey: Record<
  ParticipantVideoDisableReason,
  keyof Stats
> = {
  [ParticipantVideoDisableReason.PoorQuality]:
    'participantVideoDisabledByQuality',
  [ParticipantVideoDisableReason.Other]:
    'participantVideoDisabledByOtherReason',
  [ParticipantVideoDisableReason.Unsubscribed]:
    'participantVideoDisabledByOptimization',
  [ParticipantVideoDisableReason.NotPublished]:
    'participantVideoDisabledByTurningOff',
};

// Record<sessionId, { reasonX: count, reasonY: count }
type StatsBySession = Record<string, Stats>;

export class SubscriberVideoStatsAggregator {
  /**
   * Keeps track on all participant video disabled events for all sessions.
   */
  private stats: StatsBySession = {};

  onVideoDisabled({
    sessionId,
    reason,
  }: {
    sessionId: string;
    reason: ParticipantVideoDisableReason;
  }): void {
    const sessionStats = this.getAggregated(sessionId);

    this.stats[sessionId] = sessionStats;

    const key = disabledReasonsToStatKey[reason];

    sessionStats[key] += 1;
  }

  onVideoDisabledWarning({ sessionId }: { sessionId: string }): void {
    const sessionStats = this.getAggregated(sessionId);

    this.stats[sessionId] = sessionStats;

    sessionStats.participantVideoDisabledWarningByQuality += 1;
  }

  getAggregated(sessionId: string): Stats {
    return (
      this.stats[sessionId] ?? {
        participantVideoDisabledByOptimization: 0,
        participantVideoDisabledByTurningOff: 0,
        participantVideoDisabledByOtherReason: 0,
        participantVideoDisabledByQuality: 0,
        participantVideoDisabledWarningByQuality: 0,
      }
    );
  }
}
